export default __webpack_public_path__ + "static/NavArrow-a92f969cb2db9de77119eb3baa198eb3.png";